import React, { Component } from 'react'
import Switch from "react-switch";
import axios from 'axios';
import { GET_AGENTS_LIST, UPDATE_AGENT_FROM_MAIN_LIST } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';
import { Notifications } from '../common/notification';

export default class UpdateAgent extends Component {
    constructor(props) {
        super(props)
        this.state = {  
            User:getUser(),
            name:'',
            email:'',
            phone:'',
            address:'',
            commission:'',
            type:'profit',
            freq:'monthly',
            switched:false,
            userId:'',
            isLoad:false
        }

        this.onHandleChange = this.onHandleChange.bind(this)
        this.updateAgent = this.updateAgent.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
    }

    componentWillReceiveProps(newprops) {
        console.log(newprops)
        let {previousInfo} = newprops
        this.setState({
            name:previousInfo.name,
            email:previousInfo.email,
            phone:previousInfo.phone,
            address:previousInfo.address,
            commission:previousInfo.commission,
            type:previousInfo.type,
            freq:previousInfo.freq,
            switched:previousInfo.active,
            userId:previousInfo.id
        })
    }

    onHandleChange(e) {
        this.setState({[e.target.name]:e.target.value})
    }

    toggleSwitch() {
        this.setState({switched:!this.state.switched})
    }

    updateAgent() {
        const {name,email,phone,address,commission,freq,switched,User,userId} = this.state
        console.log(userId)
        var payload = {
            "name": name,
            "email": email,
            "phone": parseInt(phone),
            "address":address,
            "commission": `${commission}`,
            "type": "profit",
            "frequency": "monthly",
            "active": switched
        }
        this.setState({isLoad:true})
        var headers = { "Authorization": "Bearer " + User.token };
        axios.put(`${UPDATE_AGENT_FROM_MAIN_LIST}/${userId}/update`,payload,{headers}).then(res=>{
            if(res) {
                console.log(res)
                Notifications.notify('Agent Created',"Created",'success')
                this.props.close();
                this.props.listing();
                this.setState({isLoad:false})
            }
        }).catch(err=>{
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            this.setState({isLoad:false})   
            Notifications.notify(msessage, "Failed", "error")
        })
        
    }

    render() {
        const {name,email,phone,address,commission,freq,switched,type} = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Name</label>
                            <input type="text" className="form-control" name="name" value={name} onChange={this.onHandleChange} placeholder="Enter name" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Email</label>
                            <input type="email" className="form-control" name="email" value={email} onChange={this.onHandleChange} placeholder="Enter email" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Phone</label>
                            <input type="number" className="form-control" name="phone" value={phone} onChange={this.onHandleChange} placeholder="Enter phone" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Address</label>
                            <input type="text" className="form-control" name="address" value={address} onChange={this.onHandleChange} placeholder="Enter address" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Commission</label>
                            <input type="text" className="form-control" name="commission" value={commission} onChange={this.onHandleChange} placeholder="Enter commission" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Type</label>
                            <input type="text" className="form-control" name="type" value={type} onChange={this.onHandleChange} placeholder="Enter type" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label style={labelStyle}>Frequency</label>
                            <input type="text" className="form-control" name="freq" value={freq} onChange={this.onHandleChange} placeholder="Enter frequency" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group' style={{marginTop:'4px'}}>
                            <label style={labelStyle}>Status</label>
                            <div style={{marginTop:'4px'}}>
                                <Switch onChange={this.toggleSwitch} checked={switched} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.updateAgent}
                        disabled={this.state.isLoad}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Update Agent
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-user-plus"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
